import { SelectOptionType } from '@octano/global-ui';
import { useEffect, useMemo, useState } from 'react';
import {
  StudentInfo,
  StudyPlanEnrollmentsInfo,
} from '../../../studentFileList/types';
import StudentTabsHeader from '../StudentTabsHeader';
import AcademicHistoryTabs from './parts/AcademicHistorytabs';
import StudentAcademicHistoryInfo from './parts/StudentAcademicHistoryInfo';

interface AcademicHistoryProps {
  student: StudentInfo;
  studyPlanEnrollments: SelectOptionType[];
  studyPlanEnrollmentsInfo: StudyPlanEnrollmentsInfo[];
}

export default function AcademicHistory({
  student,
  studyPlanEnrollments,
  studyPlanEnrollmentsInfo,
}: AcademicHistoryProps) {
  const [selectedStudyPlan, setSelectedStudyPlan] = useState<
    SelectOptionType | undefined
  >(undefined);

  useEffect(() => {
    if (studyPlanEnrollments && studyPlanEnrollments.length >= 1) {
      setSelectedStudyPlan(studyPlanEnrollments[0]);
    } else {
      setSelectedStudyPlan(undefined);
    }
  }, [studyPlanEnrollments]);

  const tutor = useMemo(() => {
    return (
      studyPlanEnrollmentsInfo.find(
        (item) =>
          item.studyPlanEnrollmentId === Number(selectedStudyPlan?.value),
      )?.tutor ?? null
    );
  }, [studyPlanEnrollmentsInfo, selectedStudyPlan]);

  return (
    <>
      <StudentTabsHeader name={student.fullName} id={student.rut} />
      <StudentAcademicHistoryInfo
        studyPlanEnrollments={studyPlanEnrollments}
        tutor={tutor}
        selectedStudyPlan={selectedStudyPlan}
        setSelectedStudyPlan={setSelectedStudyPlan}
      />
      <AcademicHistoryTabs
        studyPlanEnrollmentId={selectedStudyPlan?.value.toString()}
        studyPlanEnrollmentsInfo={studyPlanEnrollmentsInfo}
      />
    </>
  );
}
